import { createSlice } from "@reduxjs/toolkit";

// Initial state populated from the useCustomRoles.js file
const initialState = {
  roles: {
    "holli.fletcher@pumpservicenetwork.com": "PSN",
    "tommy.kosek@pumpservicenetwork.com": "PSN",
    "Ryan.schechter@pumpservicenetwork.com": "PSN",
  },
  status: "idle",
  error: null,
}; 

// Create the custom roles slice
const customRolesSlice = createSlice({
  name: "customRoles",
  initialState,
  reducers: {
    setCustomRoles: (state, action) => {
      state.roles = action.payload;
    },
    addCustomRole: (state, action) => {
      const { email, role } = action.payload;
      state.roles[email] = role;
    },
    updateCustomRole: (state, action) => {
      const { email, role } = action.payload;
      state.roles[email] = role;
    },
    deleteCustomRole: (state, action) => {
      const email = action.payload;
      delete state.roles[email];
    },
  },
});

// Export actions
export const { 
  setCustomRoles, 
  addCustomRole, 
  updateCustomRole, 
  deleteCustomRole 
} = customRolesSlice.actions;

// Export selector to get the roles
export const selectCustomRoles = (state) => state.customRoles.roles;

// Export the reducer
export default customRolesSlice.reducer;